import React, { useState } from 'react';
import { useHistory } from 'react-router';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { Requester } from 'stores/RequesterStore';
import { SimpleInlineHelp } from 'components/InlineHelp';

export interface UserInputDictionary
{
  [key: string]: string,
}

interface Props
{
  userInput: UserInputDictionary,
  saveUserInput: (input: UserInputDictionary) => void,
  requester: Requester,
}

export const EditForm: React.FC<Props> = ({userInput, saveUserInput, requester}: Props) =>
{
  const [name, setName] = useState(userInput['name'] || requester.name || '');
  const [path, setPath] = useState(userInput['path'] || requester.path || '');
  const history = useHistory();

  const { uiStore, requesterStore } = useStore();
  const saveRequesterHandler = async () =>
  {
    saveUserInput({"name": name, "path": path});
    const requesterToken = requesterStore.requester.data?.token || '';
    await requesterStore.updateAsync(requesterToken, name, path);
    if (!requesterStore.requester.isError)
    {
      history.push(paths.buildRequesterViewPath(requesterToken));
    }
  };
  const cancelHandler = () =>
  {
    requesterStore.requester.clearError();
    history.goBack();
  }
  return (
    <>
      <div className="fields">
        <label>
          {uiStore.labels.common.forms.requester.token.label}:
          <input type="text" value={requester.token} readOnly={true} />
        </label>
        <label>
          {uiStore.labels.common.forms.requester.name.label}:
          <input type="text" placeholder={uiStore.labels.common.forms.requester.name.placeholder} value={name} onChange={e => setName(e.target.value)} />
        </label>
        <label>
          {uiStore.labels.common.forms.requester.path.label}:<SimpleInlineHelp>{uiStore.labels.help.audience.requesters.path.about}</SimpleInlineHelp>
          <input type="text" placeholder={uiStore.labels.common.forms.requester.path.placeholder} value={path} onChange={e => setPath(e.target.value)} />
        </label>

        <div className="info">
          <p>{uiStore.labels.common.forms.requester.createdBy.apply({by: requester.created_by, at: new Date(Date.parse(requester.created_at || '')).toLocaleString(),})}</p>
          <p>{uiStore.labels.common.forms.requester.updatedBy.apply({by: requester.updated_by, at: new Date(Date.parse(requester.updated_at || '')).toLocaleString(),})}</p>
        </div>
      </div>

      <div className="actions">
        <button onClick={saveRequesterHandler}>{uiStore.labels.common.forms.save}</button>
        <button onClick={cancelHandler}>{uiStore.labels.common.forms.cancel}</button>
      </div>
    </>
  );
};